import { useTranslation } from 'react-i18next';

import AISparkles from '@/components/common/AISparkles';
import SubPageHeader from '@/components/common/SubPageHeader';
import ConceptReplyConversation from '@/features/compose/components/ConceptReplyConversation';
import useConceptReply from '@/features/compose/hooks/useConceptReply';

export default function ConceptReplyPage() {
  const { t } = useTranslation();
  const { concept, initialRequest, retry, trackCopied, trackRated } =
    useConceptReply();

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>
        <span className="flex items-center gap-1.5 text-sm">
          <AISparkles />

          {t('CONCEPT_REPLY_TITLE')}
        </span>
      </SubPageHeader>

      <main className="min-h-0 flex-1 p-2">
        {!concept && (
          <p className="text-muted-foreground text-sm">
            {t('CONCEPT_REPLY_EMPTY')}
          </p>
        )}

        {initialRequest && concept && (
          <ConceptReplyConversation
            request={initialRequest}
            concept={concept}
            onRetry={retry}
            onCopied={trackCopied}
            onRated={trackRated}
          />
        )}
      </main>
    </div>
  );
}
